import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

export default function BookingSubmitted() {
  const { bookingId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="mobile-container min-h-screen flex items-center justify-center p-6">
      <Card className="p-8 text-center glass-card max-w-md w-full" data-testid="booking-submitted">
        <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-12 h-12 text-success" />
        </div>
        <h1 className="text-3xl font-black font-heading uppercase mb-3">Request Submitted!</h1>
        <p className="text-muted-foreground mb-6">
          Your booking request has been received. You'll be notified once courts are assigned.
        </p>
        <p className="text-sm text-muted-foreground mb-8">
          Booking ID: <span className="font-mono">{bookingId}</span>
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => navigate(`/booking/${bookingId}`)}
            data-testid="view-booking-button"
            className="w-full btn-volt h-14"
          >
            View Booking
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/home')}
            data-testid="back-home-button"
            className="w-full h-14 rounded-full"
          >
            Back to Home
          </Button>
        </div>
      </Card>
    </div>
  );
}